import { get } from 'lodash'
import { createI18n } from 'vue-i18n'
import { z } from 'zod'
import { useStorage } from '@/composables/use-storage'
import { LocalStorageKey } from '@/enums/local-storage-key'
import { Locale } from '@/enums/locale'
import en from './langs/en.json'
import zhTW from './langs/zh-TW.json'

const i18n = createI18n({
  locale: getDefaultLocale(),
  fallbackLocale: getDefaultFallbackLocale(),
  legacy: false,
  messages: {
    [Locale.EN_US]: en,
    [Locale.ZH_TW]: zhTW
  },
  messageResolver: (obj, path) =>
    get(obj, path, '')?.replace(/@/g, "{'@'}") || null
})

/**
 * 取得預設語系，優先順序如下
 * 1. 網址有加 ?lang=語系，且系統支援該語系時，使用該語系，否則使用 en（在 app.vue 實作此功能）
 * 2. Local Storage 有儲存語系，且系統支援該語系時，使用該語系，否則判斷第 3 點
 * 3. 瀏覽器語系為 zh 時，使用 zh，否則使用 en
 */
function getDefaultLocale(): Locale {
  const { getStorageData } = useStorage()
  const localStorageLang = getStorageData({
    key: LocalStorageKey.LOCALE,
    zodSchema: z.nativeEnum(Locale)
  })

  // 系統支援 Local Storage 所儲存的語系時，使用該語系
  if (localStorageLang) {
    return localStorageLang
  }

  // 瀏覽器語系為 zh 時，使用 zh，否則使用 en
  return navigator.language === Locale.ZH_TW ? navigator.language : Locale.EN_US
}

/** 取得無設定語系檔時，默認的語系 */
function getDefaultFallbackLocale(): Locale {
  return navigator.language === Locale.ZH_TW ? Locale.ZH_TW : Locale.EN_US
}

export default i18n
